<template>
  <div class="enterprise-list-page enterprise-list-page--lab-report">

    <!-- Header Card -->
        <PageHeader icon="fas fa-vials">
      <template #title>
        Hasil Pemeriksaan Laboratorium
      </template>
      <template #subtitle>
        Tinjau dan kelola hasil pengujian laboratorium pasien
      </template>
      <template #actions>
        <b-button v-if="canOperate" class="btn btn-light font-weight-bold mr-2" @click="$router.push('/lab-report-2/operations')">
          <i class="fas fa-clipboard-check"></i><span> Ringkasan & Proses</span>
        </b-button>
        <b-button
                class="btn btn-primary font-weight-bold px-6 hc-btn-tambah-jadwal"
                v-if="manipulateBtn == true"
                @click="$router.push('/lab-report-2/add')">
                <i class="fas fa-plus"></i>
                <span>Input Hasil</span>
              </b-button>
      </template>
    </PageHeader>

    <div class="row">
      <div class="col-md-12">
        <Card>
          <template v-slot:body>
            <Table
              :fields="fields"
              :items="items"
              purpose="master"
              :perPage="perPage"
              :currentPage="currentPage"
              :totalRows="totalRows"
              @filterByPatient="filterByPatient"
              @filter="generalFilter"
              @btnDeleteOnClick="btnDeleteOnClick"
              @pageOnClick="pageOnClick"
            />
          </template>
        </Card>
      </div>
    </div>

  </div>
</template>

<script>

import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module"
import Card from '@/view/content/Card.vue'
import Table from '@/component/lab-reports-2/Table.vue'
import module from '@/core/modules/CrudModule.js'
import { getUser } from '@/core/services/jwt.service.js'

export default {

  components: {
    Card,
    Table
  },

  data() {
    return {
      // Filter
      filter: {
        doctor_id: '',
        patient_name: '',
        start_date: '',
        end_date: ''
      },
      // Pagination
      perPage: 20,
      currentPage: 1,
      totalRows: 0,
      // Table Fields
      fields: [
        {
          key: "number",
          label: '#',
          sortable: true,
        },
        {
          key: "accession_number",
          label: "No. Hasil",
          sortable: true,
        },
        {
          key: "display_date",
          label: "Tanggal",
          sortable: true,
        },
        {
          key: "patient_name",
          label: "Pasien",
          sortable: true,
        },
        {
          key: "doctor_name",
          label: "Dokter",
          sortable: true,
        },
        { key: "lab_category_name", label: "Kategori" },
        { key: "workflow_status", label: "Status" },
        { key: "actions", label: "Aksi" },
      ],
      // Table Items
      items: [],
      manipulateBtn: false,
      canOperate: false,
      // current user
      currentUser: getUser()
    }
  },

  methods: {

    pageOnClick(page) {
      this.currentPage = page
      this.pagination()
    },

    async pagination() {
      let route
      if (this.currentUser.user_type_id == 1) {
        route = `lab-reports/get-by-doctor/${this.currentUser.user_id}`
      } else {
        route = 'lab-reports'
      }
      let filterParams = `&doctor_id=${this.filter.doctor_id}&patient_name=${this.filter.patient_name}&start_date=${this.filter.start_date}&end_date=${this.filter.end_date}`
      let response = await module.paginate(route, `?page=${this.currentPage}&page_size=${this.perPage}${filterParams}`)
      let pagination = response.meta.pagination
      this.totalRows = pagination.total

      let a, b
      b = this.perPage * (this.currentPage - 1) + 1
      for (a = 0; a < response.data.length; a++) {
        response.data[a].number = b + a
      }
      this.items = response.data
    },

    resetFilter() {
      if (this.currentUser.user_type_id != 1) {
        this.filter.doctor_id = ''
      }
      this.filter.start_date = ''
      this.filter.end_date = ''
    },

    filterByPatient(sended) {
      this.generalFilter(sended)
    },

    generalFilter(sended) {
      this.currentPage = 1
      this.filter.doctor_id = sended.doctor_id
      this.filter.patient_name = sended.patient_name
      this.filter.start_date = sended.start_date
      this.filter.end_date = sended.end_date
      this.pagination()
    },

    async btnDeleteOnClick(id) {
      // Delete Data
      let result = await module.delete('lab-reports/' + id)
      // If Deleted
      if (result) {
        this.pagination()
      }
    },

    // access management
    async setActiveMenu() {

      let access_right_user = window.localStorage.getItem("access_right_display")
      let access_right = JSON.parse(access_right_user)

      let a
      for (a = 0; a < access_right.length; a++) {
        

        if (access_right[a] == "1104") {
          this.manipulateBtn = true
        }
        if (["1104", "1107"].includes(String(access_right[a]))) this.canOperate = true

      }
    },

  },

  mounted() {
    // BreadCrumb
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Pemeriksaan Lab" },
      { title: "Hasil Pemeriksaan" },
    ])
    // Get Table Data
    this.pagination()
    this.setActiveMenu()
  },

}
</script>

<style>
</style>
